import {PageManager} from 'genesis-packages/core';
import './WLST.scss';

export default class WLST extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
